import HttpClient from '../http-client';

const resource = '/voice';

export default {
    /**
     * Change Voice to streamer when voice is set as free
     * @param {string} twitchAuthToken
     * @param {string} voiceId
     * @param {string} channelId
     * @param {number} seconds
     * @param {number} bits
     * @param {string} version - Voice version
     */
    changeFreeVoice(twitchAuthToken, voiceId, channelId, seconds, bits, version) {
        const data = JSON.stringify({
            voiceId,
            channelId,
            seconds,
            bits,
            version,
        });

        const requestConfig = {
            headers: {
                'Custom-Authorization': `Bearer ${twitchAuthToken}`,
                'Content-Type': 'application/json',
            },
        };

        return HttpClient.post(`${resource}/change-free`, data, requestConfig);
    },

    /**
     * Change Voice to streamer when voice is set as free
     * @param {string} transactionReceipt
     * @param {string} transactionId
     * @param {string} voiceId
     * @param {string} channelId
     * @param {number} seconds
     * @param {number} bits
     * @param {string} version - Voice version
     */
    changeVoice(transactionReceipt, transactionId, voiceId, channelId, seconds, bits, version) {
        const data = JSON.stringify({
            transactionId,
            voiceId,
            channelId,
            seconds,
            bits,
            version,
        });

        const requestConfig = {
            headers: {
                'Custom-Authorization': `Bearer ${transactionReceipt}`,
                'Content-Type': 'application/json',
            },
        };

        return HttpClient.post(`${resource}/change`, data, requestConfig);
    },
};
